import { ReviewCardProps } from '../../interfaces/common'

const ReviewCard = ({
  name,
  email,
  role,
  description,
  estate,
  date,
  imgSrc,
}: ReviewCardProps) => (
  <div className="bg-[#f4f4f5] dark:bg-[#222121] p-6 rounded-lg flex flex-col space-y-4 dark:hover:bg-[#5e5e5e] ml-4">
    {/* Header */}
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-1">
        <img
          src={imgSrc}
          alt={name}
          className="w-[58.41px] h-[58.41px] rounded-full object-cover" />
        <div className="flex space-x-2">
          <div>
            <h2 className="text-black font-medium dark:text-gray-100 text-[16px] leading-[18.77px]">
              {name}
            </h2>
            <p className="text-[16px] leading-[18.77px] font-normal text-[#AAACAF] dark:text-gray-300">
              {role}
            </p>
          </div>

          {/* <p className="md:text-[17.52px] text-[12px] leading-[20.55px] font-normal text-gray-500 dark:text-gray-300">
            {email}
          </p> */}
        </div>
      </div>
    </div>

    {/* Description */}
    <p className="text-[#696A6C] dark:text-gray-300 font-normal text-[16px] md:text-[16px] leading-[18.77px] border-t border-dashed border-[#ADB5BD] dark:border-gray-300 pt-4">
      {description}
    </p>

    {/* Footer */}
    <div className="flex justify-between items-center border-t border-dashed border-[#ADB5BD] dark:border-gray-300 pt-3">
      <p className="text-gray-900 dark:text-gray-300 font-normal text-[17.52px] leading-[20.55px]">
        {estate}
      </p>
      <p className="text-gray-500 dark:text-gray-400 font-normal text-[17.52px] leading-[20.55px]">
        {date}
      </p>
    </div>
  </div>
)

export default ReviewCard
